import { render, staticRenderFns } from "./default.vue?vue&type=template&id=784aaf10&scoped=true"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"
import style0 from "./default.vue?vue&type=style&index=0&id=784aaf10&prod&lang=scss"
import style1 from "./default.vue?vue&type=style&index=1&id=784aaf10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784aaf10",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/home/travis/build/Polumathes/LTNG-1800-Frontend/components/HeaderElements/Header.vue').default,HeaderLarge: require('/home/travis/build/Polumathes/LTNG-1800-Frontend/components/HeaderElements/HeaderLarge.vue').default,Footer: require('/home/travis/build/Polumathes/LTNG-1800-Frontend/components/FooterElements/Footer.vue').default,ButtonsButtonLiveChat: require('/home/travis/build/Polumathes/LTNG-1800-Frontend/components/Buttons/ButtonLiveChat.vue').default,ButtonsButtonEscape: require('/home/travis/build/Polumathes/LTNG-1800-Frontend/components/Buttons/ButtonEscape.vue').default,ModalsExternalLink: require('/home/travis/build/Polumathes/LTNG-1800-Frontend/components/Modals/ExternalLink.vue').default,ModalsDisclaimerModal: require('/home/travis/build/Polumathes/LTNG-1800-Frontend/components/Modals/DisclaimerModal.vue').default})
